import { type ReactElement, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

type VisibleCenterProps = {
  children: ReactNode;
  className?: string;
};

/**
 * Centers a full-width table message (empty, loading, error) on the part of
 * the table the user can see, not on the table's whole scroll width
 * (KIR-5640: "No running processes found." was centered on a table wider than
 * its container, so it was clipped at the visible right edge).
 *
 * Sticky `left: 50%` resolves against the scroll container's visible width,
 * and `-translate-x-1/2` then puts the message's middle there. The message
 * stays put while the table scrolls sideways, and `max-w-full` keeps a long
 * one inside its cell.
 */
export function VisibleCenter({
  children,
  className,
}: VisibleCenterProps): ReactElement {
  return (
    <div
      data-slot="table-state-message"
      className={cn(
        'sticky left-1/2 w-fit max-w-full -translate-x-1/2 text-center',
        className
      )}
    >
      {children}
    </div>
  );
}
